import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
var ArticlePager = function(param) {
    var count = param.count, pageSize = param.pageSize, pageNumber = param.pageNumber, setPageSize = param.setPageSize, setPageNumber = param.setPageNumber;
    var sizes = [
        10,
        20,
        50,
        100
    ];
    var nodeRef = useRef(null);
    var ref = useState(false), showDropDown = ref[0], setShowDropDown = ref[1];
    useEffect(function() {
        document.addEventListener("mousedown", handleClick);
        return function() {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);
    useEffect(function() {
        setShowDropDown(false);
    }, [
        pageSize
    ]);
    var handleClick = function(event) {
        if (!nodeRef.current.contains(event.target)) {
            setShowDropDown(false);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "pt-3 flex justify-end",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pt-3 flex items-center",
            ref: nodeRef,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "mr-2",
                    children: "Items per page:"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mr-2",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                className: "relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                                onClick: function() {
                                    return setShowDropDown(!showDropDown);
                                },
                                type: "button",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "ml-3 block truncate",
                                            children: pageSize
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                        children: /*#__PURE__*/ _jsx("svg", {
                                            "aria-hidden": "true",
                                            className: "h-5 w-5 text-gray-400",
                                            fill: "currentColor",
                                            viewBox: "0 0 20 20",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ _jsx("path", {
                                                clipRule: "evenodd",
                                                d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                                fillRule: "evenodd"
                                            })
                                        })
                                    })
                                ]
                            }),
                            showDropDown && /*#__PURE__*/ _jsx("div", {
                                className: "absolute mt-1 w-full rounded-md bg-white shadow-lg",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    "aria-activedescendant": "listbox-item-3",
                                    "aria-labelledby": "listbox-label",
                                    className: "max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                    role: "listbox",
                                    children: sizes.map(function(size) {
                                        return /*#__PURE__*/ _jsx("li", {
                                            className: "text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9",
                                            id: "listbox-item-0",
                                            onClick: function() {
                                                return setPageSize(size);
                                            },
                                            role: "option",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: "ml-3 block font-normal",
                                                    children: size
                                                })
                                            })
                                        }, size);
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mr-4",
                    children: [
                        pageNumber * pageSize + 1,
                        " - ",
                        (pageNumber + 1) * pageSize < count ? (pageNumber + 1) * pageSize : count,
                        " of ",
                        count
                    ]
                }),
                /*#__PURE__*/ _jsx("button", {
                    className: "mr-2",
                    disabled: pageNumber <= 0,
                    onClick: function() {
                        return setPageNumber(pageNumber - 1);
                    },
                    children: /*#__PURE__*/ _jsx(MdNavigateBefore, {
                        color: pageNumber <= 0 ? "grey" : "black",
                        size: 30
                    })
                }),
                /*#__PURE__*/ _jsx("button", {
                    disabled: count <= (pageNumber + 1) * pageSize,
                    onClick: function() {
                        return setPageNumber(pageNumber + 1);
                    },
                    children: /*#__PURE__*/ _jsx(MdNavigateNext, {
                        color: count <= (pageNumber + 1) * pageSize ? "grey" : "black",
                        size: 30
                    })
                })
            ]
        })
    });
};
export default ArticlePager;
